// src/pages/Schedule.js
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import { useSearchParams, useNavigate } from 'react-router-dom';
import EstimateCalendar from '../components/scheduling/EstimateCalendar';
import ScheduleEstimateModal from '../components/estimates/ScheduleEstimateModal';
import './Schedule.css';

const Schedule = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [showNewEstimateAlert, setShowNewEstimateAlert] = useState(false);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [newEstimateId, setNewEstimateId] = useState(null);

  // Check for URL parameters to determine initial view
  useEffect(() => {
    const newEstimate = searchParams.get('newEstimate');

    if (newEstimate) {
      setNewEstimateId(parseInt(newEstimate));
      setShowScheduleModal(true);
      setShowNewEstimateAlert(true);
      // Auto-hide the alert after 8 seconds
      setTimeout(() => setShowNewEstimateAlert(false), 8000);
    }
  }, [searchParams]);

  const handleScheduleModalClose = () => {
    setShowScheduleModal(false);
    setNewEstimateId(null);
    // Clear the URL parameters
    navigate('/schedule', { replace: true });
  };

  const handleEstimateScheduled = (scheduledEstimate) => {
    setShowNewEstimateAlert(false);
    // The calendar will refresh and show the newly scheduled estimate
  };

  return (
    <Container fluid className="schedule-page-container">
      {/* Show alert for new estimate creation */}
      {showNewEstimateAlert && (
        <Row className="justify-content-center mb-3">
          <Col xs={12} md={10} lg={8}>
            <Alert variant="success" dismissible onClose={() => setShowNewEstimateAlert(false)}>
              <Alert.Heading>Estimate Created Successfully!</Alert.Heading>
              <p>Use the scheduling modal to set up an appointment for your new estimate.</p>
            </Alert>
          </Col>
        </Row>
      )}

      <EstimateCalendar />

      {/* Schedule Estimate Modal */}
      <ScheduleEstimateModal
        show={showScheduleModal}
        estimateId={newEstimateId}
        onClose={handleScheduleModalClose}
        onScheduled={handleEstimateScheduled}
      />
    </Container>
  );
};

export default Schedule;